import React from "react";
import ProductType from "../../../common/interfaces/enums/ProductType";
import GlobalProductFormLife from "./GlobalProductForms/GlobalProductFormLife";
import GlobalProductFormMortgage from "./GlobalProductForms/GlobalProductFormMortgage";

interface IGlobalProductFormProps {
    productType: ProductType;
}

const GlobalProductForm: React.FC<IGlobalProductFormProps> = ({ productType }) => {
    switch (productType) {
        case ProductType.Life:
            return <GlobalProductFormLife />;

        case ProductType.Mortgage:
            return <GlobalProductFormMortgage />;

        default:
            return null;
    }
};

export default GlobalProductForm;
